import { useTranslation } from 'module/hooks/use-translation';
import { Modal } from 'module/ui/components/atoms/modal';
import { Button, InputField } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-03);
`;

const Body = styled.div`
  margin-top: var(--spacing-03);
`;

type TemplateNameConflictModalProps = {
  open: boolean;
  name: string;
  errorMessage?: string;
  isSubmitting: boolean;
  onNameChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
};

export const TemplateNameConflictModal = ({
  open,
  name,
  errorMessage,
  isSubmitting,
  onNameChange,
  onCancel,
  onSave,
}: TemplateNameConflictModalProps) => {
  const placeholder = useTranslation('template_name_conflict.placeholder');
  const canSave = name.trim().length > 0 && !isSubmitting;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={<FormattedMessage id="template_name_conflict.title" />}
      footer={
        <Footer>
          <Button
            variant="secondary"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            <FormattedMessage id="cancel" />
          </Button>
          <Button
            variant="primary"
            onClick={onSave}
            disabled={!canSave}
            loading={isSubmitting}
          >
            <FormattedMessage id="save" />
          </Button>
        </Footer>
      }
      width={480}
      destroyOnClose
    >
      <Body>
        <InputField
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={placeholder}
          helperText={errorMessage}
          helperTextType="error"
          onPressEnter={() => {
            if (canSave) {
              onSave();
            }
          }}
          autoFocus
        />
      </Body>
    </Modal>
  );
};
